<template>
  <div>
    <div class="md-layout withiphone">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
        :class="subdomain"
      >
        <div id="menu" class="md-layout-item md-size-100 md-medium-size-100">
          <div class="md-card">
            <div class="linkcontainer">
              <span
                class="ml-2 instagram"
                v-if="stablishment && stablishment.instagram"
              >
                <a :href="stablishment.instagram" target="_blank">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30px"
                    height="30px"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill="currentColor"
                      d="M8 0C5.829 0 5.556.01 4.703.048C3.85.088 3.269.222 2.76.42a3.9 3.9 0 0 0-1.417.923A3.9 3.9 0 0 0 .42 2.76C.222 3.268.087 3.85.048 4.7C.01 5.555 0 5.827 0 8.001c0 2.172.01 2.444.048 3.297c.04.852.174 1.433.372 1.942c.205.526.478.972.923 1.417c.444.445.89.719 1.416.923c.51.198 1.09.333 1.942.372C5.555 15.99 5.827 16 8 16s2.444-.01 3.298-.048c.851-.04 1.434-.174 1.943-.372a3.9 3.9 0 0 0 1.416-.923c.445-.445.718-.891.923-1.417c.197-.509.332-1.09.372-1.942C15.99 10.445 16 10.173 16 8s-.01-2.445-.048-3.299c-.04-.851-.175-1.433-.372-1.941a3.9 3.9 0 0 0-.923-1.417A3.9 3.9 0 0 0 13.24.42c-.51-.198-1.092-.333-1.943-.372C10.443.01 10.172 0 7.998 0zm-.717 1.442h.718c2.136 0 2.389.007 3.232.046c.78.035 1.204.166 1.486.275c.373.145.64.319.92.599s.453.546.598.92c.11.281.24.705.275 1.485c.039.843.047 1.096.047 3.231s-.008 2.389-.047 3.232c-.035.78-.166 1.203-.275 1.485a2.5 2.5 0 0 1-.599.919c-.28.28-.546.453-.92.598c-.28.11-.704.24-1.485.276c-.843.038-1.096.047-3.232.047s-2.39-.009-3.233-.047c-.78-.036-1.203-.166-1.485-.276a2.5 2.5 0 0 1-.92-.598a2.5 2.5 0 0 1-.6-.92c-.109-.281-.24-.705-.275-1.485c-.038-.843-.046-1.096-.046-3.233s.008-2.388.046-3.231c.036-.78.166-1.204.276-1.486c.145-.373.319-.64.599-.92s.546-.453.92-.598c.282-.11.705-.24 1.485-.276c.738-.034 1.024-.044 2.515-.045zm4.988 1.328a.96.96 0 1 0 0 1.92a.96.96 0 0 0 0-1.92m-4.27 1.122a4.109 4.109 0 1 0 0 8.217a4.109 4.109 0 0 0 0-8.217m0 1.441a2.667 2.667 0 1 1 0 5.334a2.667 2.667 0 0 1 0-5.334"
                    />
                  </svg>
                </a>
              </span>
              <span
                class="ml-2 website"
                v-if="stablishment && stablishment.website"
              >
                <a :href="stablishment.website" target="_blank">
                  <svg
                    height="30px"
                    width="30px"
                    version="1.1"
                    id="Capa_1"
                    xmlns="http://www.w3.org/2000/svg"
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    viewBox="0 0 107.366 107.366"
                    xml:space="preserve"
                    fill="#000000"
                  >
                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                    <g
                      id="SVGRepo_tracerCarrier"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></g>
                    <g id="SVGRepo_iconCarrier">
                      <g>
                        <path
                          style="fill: #010002"
                          d="M107.366,53.683C107.366,24.082,83.283,0,53.683,0c-4.982,0-9.785,0.734-14.366,2.011L39.21,1.94 c-0.025,0.036-0.043,0.075-0.068,0.115C16.595,8.417,0,29.125,0,53.683c0,29.601,24.082,53.683,53.683,53.683 c4.985,0,9.785-0.734,14.366-2.011l0.107,0.075c0.025-0.036,0.047-0.075,0.068-0.115C90.77,98.948,107.366,78.237,107.366,53.683z M5.343,56.292H24.69c0.193,5.766,0.837,11.438,2.004,16.942H9.366C7.047,68.002,5.662,62.29,5.343,56.292z M102.022,51.077H82.679 c-0.197-5.769-0.837-11.442-2.008-16.946H98C100.319,39.364,101.704,45.076,102.022,51.077z M77.468,51.077h-21.18V34.131h19.061 C76.58,39.625,77.264,45.298,77.468,51.077z M56.292,28.924V5.343c2.53,0.136,5.014,0.415,7.43,0.923 c4.502,6.986,7.97,14.595,10.289,22.658H56.292z M51.077,28.924h-18.12c2.137-7.92,5.354-15.436,9.57-22.368 c2.766-0.655,5.622-1.056,8.55-1.213V28.924z M51.077,34.132v16.946H29.84c0.111-5.766,0.712-11.442,1.85-16.946H51.077z M24.633,51.077H5.34c0.319-6.002,1.704-11.717,4.023-16.946h17.046C25.335,39.654,24.741,45.319,24.633,51.077z M29.898,56.292 h21.18v16.942H32.013C30.785,67.74,30.102,62.068,29.898,56.292z M51.077,78.441v23.581c-2.53-0.136-5.018-0.415-7.43-0.923 c-4.502-6.986-7.97-14.595-10.293-22.658C33.355,78.441,51.077,78.441,51.077,78.441z M56.292,78.441h18.116 c-2.14,7.92-5.354,15.432-9.57,22.368c-2.766,0.659-5.622,1.056-8.55,1.213V78.441H56.292z M56.292,73.234V56.292h21.237 c-0.111,5.762-0.712,11.438-1.854,16.942C75.675,73.234,56.292,73.234,56.292,73.234z M82.732,56.292h19.294 c-0.319,6.002-1.704,11.714-4.023,16.942H80.957C82.031,67.712,82.625,62.047,82.732,56.292z M95.28,28.924H79.393 c-1.943-7.147-4.681-13.993-8.235-20.403C81.294,12.454,89.765,19.694,95.28,28.924z M35.219,8.883 c-3.31,6.32-5.848,13.041-7.627,20.038H12.086C17.425,19.991,25.514,12.898,35.219,8.883z M12.086,78.441h15.89 c1.94,7.147,4.678,13.993,8.231,20.403C26.072,94.911,17.601,87.671,12.086,78.441z M72.146,98.483 c3.31-6.32,5.848-13.041,7.627-20.038H95.28C89.94,87.374,81.852,94.467,72.146,98.483z"
                        ></path>
                      </g>
                    </g>
                  </svg>
                </a>
              </span>
            </div>

            <div
              v-if="stablishment !== undefined && stablishment.coverImage"
              class="w-100 mb-1 imagebanner"
            >
              <img :src="stablishment.coverImage" class="w-100 coverimage" />
              <div class="logorestocontainer">
                <div
                  class="logoresto"
                  :style="'background:url(' + stablishment.logo + ')'"
                ></div>
              </div>
            </div>

            <div class="md-card-content">
              <div class="mb-4">
                <div
                  class="md-layout-item float-left md-size-100 logotitle align-center"
                >
                  <h2
                    v-if="stablishment !== undefined && stablishment.name"
                    class="titlemenu mb-0 text-primary"
                    :style="'color:' + stablishment.secondaryColor"
                  >
                    {{ stablishment.name }}
                  </h2>
                </div>
                <h4 class="text-center text-primary">
                  <span v-if="customerName">{{ customerName }}</span>
                </h4>
                <div class="w-100 my-3" v-if="token">
                  <avatar
                    :logo="profile.avatar ? profile.avatar : image"
                  ></avatar>

                  <h5
                    v-if="
                      profile.daysDifference > 0 && profile.daysDifference < 10
                    "
                    class="text-center text-white bg-primary py-2 border-radius mt-4"
                  >
                    <i class="material-icons text-white">warning</i>
                    {{ $t("payment_due", { days: profile.daysDifference }) }}
                  </h5>

                  <h5
                    v-if="profile.daysDifference <= 0"
                    class="text-center text-white bg-danger py-2 border-radius mt-4"
                  >
                    <i class="material-icons text-white">warning</i>
                    {{
                      $t("payment_overdue", {
                        days: Math.abs(profile.daysDifference),
                      })
                    }}
                  </h5>

                  <h5
                    class="text-center mt-4 text-primary"
                    v-if="profile.paymentType == 'month' && profile.paymentDate"
                  >
                    {{ $t("paymentDate") }} {{ labelDate(profile.paymentDate) }}
                  </h5>
                </div>
                <div class="text-center mb-2">
                  <span
                    v-if="
                      (profile.access < 0 || profile.access == null) &&
                      profile.paymentType == 'month'
                    "
                    class="p-1"
                  >
                    <small class="badge badge-primary text-white">
                      <i class="material-icons text-white">meeting_room</i>
                      <i class="material-icons text-white">all_inclusive</i>
                      {{ $t("unlimitedAccess") }}
                    </small>
                  </span>
                  <span v-if="profile.cupos < 0" class="p-1">
                    <small class="badge badge-primary text-white">
                      <i class="material-icons text-white">self_improvement</i>
                      <i class="material-icons text-white">all_inclusive</i>
                      {{ $t("unlimitedQuota") }}
                    </small>
                  </span>
                  <span
                    v-if="profile.cupos == 0 || profile.cupos == null"
                    class="p-1"
                  >
                    <small class="badge badge-primary text-white">
                      <i class="material-icons text-white">self_improvement</i>
                      <span>0 {{ $t("availableSlots") }}</span>
                    </small>
                  </span>
                  <span v-if="profile.cupos > 0" class="p-1">
                    <small class="badge badge-primary text-white">
                      <i class="material-icons text-white">self_improvement</i>
                      <span v-if="profile.remainingCupos > 0"
                        >{{ profile.remainingCupos }}
                        {{ $t("availableSlots") }}</span
                      >
                      <span v-else>{{ $t("noQuotaLeft") }}</span>
                    </small>
                  </span>
                  <span>
                    <span v-if="profile.access > 0" class="p-1">
                      <small class="badge badge-primary text-white">
                        <i class="material-icons text-white">meeting_room</i>
                        <span
                          >{{ profile.remainingAccess }}
                          {{ $t("remainingAccesses") }}</span
                        >
                      </small>
                    </span>
                  </span>
                </div>
                <div v-if="token && order && !loading" class="w-100">
                  <AnonymousResult
                    :isInDashboard="true"
                    :isWebsocket="false"
                    :defaultOrderId="order.access._id"
                  />
                </div>
                <div class="text-center card p-2" v-if="profile.accessButton">
                  <div>
                    <button
                      class="md-button md-lg w-100"
                      :style="
                        stablishment !== undefined && stablishment.name
                          ? buttonStyle(stablishment.primaryColor)
                          : ''
                      "
                      :disabled="!validateForm()"
                      @click="submitForm"
                    >
                      <i class="material-icons">meeting_room</i>
                      <span class="pr-1">Marcar Ingreso</span>
                    </button>
                  </div>
                </div>

                <div class="w-100 text-center mt-4">
                  <router-link
                    class="md-primary"
                    :to="{ path: '/dashboard' }"
                    v-if="token"
                  >
                    <strong>{{ $t("dashboard") }}</strong>
                  </router-link>
                </div>
              </div>

              <MyClasses
                v-if="token && role == 'client'"
                @deleted="deletedClass"
                :key="reloadclasses"
              />
              <ScheduleWeekGym
                @refreshComponent="deletedClass"
                :key="reloadActivities"
                :phone="true"
                :qr="true"
                :edit="false"
                v-if="!loading"
              />
            </div>
            <div class="bg-white card p-2 termsanonymous text-center">
              <a
                href="https://gotake.it"
                target="_blank"
                class="mb-2 text-center"
              >
                <img
                  :src="'/img/gotakeit.png'"
                  width="80px"
                  title=""
                  class="mr-2"
                  style="width: 80px; margin: 0 auto"
              /></a>
              <small class="text-secondary"
                >{{ $t("consentNotice") }}
                <strong
                  ><a class="text-primary" href="/terms" target="_blank">{{
                    $t("termsLinkText")
                  }}</a></strong
                ></small
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
// Mock function to replace non-existent import
const createAccessAction = async (data) => {
  console.warn(
    "createAccessAction is not available - Orders actions module was removed"
  );
  return { success: false, message: "Create access not available" };
};
import { getUserAction, getMyProfileAction } from "@/pages/Users/actions";
import { i18n } from "@/i18n";
import NewUserForm from "@/pages/Dashboard/Pages/UserProfile/NewUserForm.vue";
import permissionsMixin from "@/mixins/permissionsMixin";
import { logoutAction } from "@/pages/Auth/actions";
// Mock component to replace non-existent import
const AnonymousResult = {
  template: "<div>AnonymousResult component not available</div>",
  name: "AnonymousResult",
};
import { format, isBefore, isToday } from "date-fns";

import { Avatar, MyClasses, ScheduleWeekGym } from "@/components";

export default {
  mixins: [permissionsMixin],
  data() {
    return {
      subdomain: "",
      image: "/img/placeholder.jpg",
      qrName: false,
      profile: false,
      identifier: "",
      token: false,
      role: false,
      order: false,
      totalPriceOrders: 0,
      pendingOrders: false,
      clientSecret: false,
      activeCategory: 0,
      business: false,
      opencollapse: false,
      opencollapsefirst: true,
      stablishment: false,
      reloadActivities: 122323,
      reloadclasses: 3232,
      menu: false,
      selected: [],
      cart: [],
      categorieslabels: [],
      responsive: false,
      categories: [],
      customerName: "",
      customerEmail: "",
      customerPhone: "",
      customerAvatar: "",
      customerComments: "",
      selectedCountryCode: "+34",
      terms: [],
      loading: false,
      obteniendoperfil: false,
      obteniendoperfilOK: false,
      obteniendoQR: false,
      obteniendoQROK: false,
      creandoacceso: false,
      creandoaccesoOK: false,
    };
  },
  watch: {
    isCollapseOpen(newVal) {
      this.opencollapse = newVal;
    },
  },
  components: {
    ScheduleWeekGym,
    NewUserForm,
    Avatar,
    MyClasses,
    AnonymousResult,
  },
  computed: {
    isFormValid() {
      if (this.menu.requestAdditionalInfo) {
        return (
          this.customerName &&
          this.customerEmail &&
          this.customerPhone &&
          this.isValidEmail(this.customerEmail)
        );
      } else {
        return this.customerName;
      }
    },
  },
  mounted() {},
  created() {
    this.loading = true;

    this.subdomain = window.location.hostname.split(".")[0];

    this.token = localStorage.getItem("token");
    this.role = localStorage.getItem("role");

    if (localStorage.getItem("customerName")) {
      this.customerName = localStorage.getItem("customerName");
    }
    if (localStorage.getItem("identifier")) {
      this.identifier = localStorage.getItem("identifier");
    }
    if (localStorage.getItem("customerAvatar")) {
      this.customerAvatar = localStorage.getItem("customerAvatar");
    }

    if (this.token) {
      this.getMyProfile();
    }

    this.getQr();

    this.loading = false;
  },
  methods: {
    async getMyProfile() {
      this.obteniendoperfil = true;
      const response = await getMyProfileAction();
      this.obteniendoperfilOK = true;
      console.log(response);
      this.profile = response;
    },
    deletedClass() {
      this.reloadActivities++;
      this.reloadclasses++;
      this.getMyProfile();
    },
    labelDate(startDate) {
      return (
        format(new Date(startDate), "dd") +
        " " +
        this.$t(format(new Date(startDate), "MMMM")) +
        " " +
        format(new Date(startDate), "yyyy")
      );
    },
    validateForm() {
      return this.identifier && this.identifier.length > 0;
    },
    async logout() {
      let urllogin = "/loginclient";

      await logoutAction();
      if (this.$route.path !== urllogin) {
        this.$router.push(urllogin);
      }
    },
    submitForm() {
      this.createOrder();
    },
    stablishmentReady() {
      return (
        this.stablishment.name !== "My Fitness" &&
        this.stablishment.name !== "Costa Azul" &&
        this.stablishment !== undefined
      );
    },
    async getQr() {
      try {
        if (!this.$route.params.id) {
          this.obteniendoQROK = true;
          return;
        }

        this.obteniendoQR = true;

        this.stablishment = response.data.stablishment;

        if (
          (this.stablishment && this.stablishment.primaryColor == "#FFFFFF") ||
          this.stablishment.primaryColor == "#ffffff" ||
          !this.stablishment.primaryColor
        ) {
          this.stablishment.primaryColor = "#333";
        }
        if (
          (this.stablishment &&
            this.stablishment.secondaryColor == "#FFFFFF") ||
          this.stablishment.secondaryColor == "#ffffff" ||
          !this.stablishment.secondaryColor
        ) {
          this.stablishment.secondaryColor = "#333";
        }

        if (this.stablishmentReady()) {
          // Cambiar el título de la página
          document.title = this.stablishment.name;
          // Cambiar el favicon de la página
          const link = document.createElement("link");
          link.rel = "icon";
          link.href = this.stablishment.logo;
          document.head.appendChild(link);
        }

        this.qrName = response.data.name;

        this.obteniendoQROK = true;
      } catch (error) {
        this.errorMessage = error.message;
      }
    },
    localDate(utcDate) {
      const date = new Date(utcDate);
      return format(date, "PPpp"); // Formato de fecha y hora según la hora local del navegador
    },
    setActiveCategory(key) {
      this.activeCategory = key;
    },
    buttonStyle(color) {
      return {
        backgroundColor: `${color} !important`,
      };
    },
    colorStyle(color) {
      return {
        color: `${color} !important`,
      };
    },

    async createOrder() {
      try {
        this.creandoacceso = true;

        const response = await createAccessAction(
          this.identifier,
          this.$route.params.id,
          this.stablishment
        );

        this.order = response.data;

        this.creandoaccesoOK = true;
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: this.$tn("identifierNotFound"),
        });
      }
    },
    preventZoom() {
      this.$el.addEventListener("dblclick", this.handleDblClick, {
        passive: false,
      });
    },
    handleDblClick(event) {
      event.preventDefault();
    },
    onSelect(items) {
      this.selected = items;
    },
    onResponsiveInverted() {
      if (window.innerWidth < 768) {
        this.responsive = true;
      } else {
        this.responsive = false;
      }
    },
  },
  mounted() {
    this.onResponsiveInverted();
    window.addEventListener("resize", this.onResponsiveInverted);

    this.preventZoom();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.onResponsiveInverted);
    this.$el.removeEventListener("dblclick", this.handleDblClick);
  },
};
</script>

<style lang="css">
.identifieranonymous .md-field,
.identifieranonymous .md-input,
.identifieranonymous .md-field {
  font-size: 20px !important;
}
.identifieranonymous .md-field::placeholder,
.identifieranonymous .md-input::placeholder,
.identifieranonymous .md-field::placeholder {
  font-size: 20px !important;
}
</style>
